module.exports = __webpack_public_path__ + "img/log.7f14c8b6.svg";